import React from 'react';
import FeatureList from './FeatureList';

const ModuleCard = ({ image, alt, title, description, features, className = "" }) => {
  return (
    <article className={`p-8 bg-white rounded-2xl shadow-[0_2px_8px_rgba(0,0,0,0.08)] max-sm:p-6 ${className}`}>
      <div className="mb-6">
        <img
          src={image}
          alt={alt}
          className="w-full h-auto rounded-[12px]"
        />
      </div>
      <h2 className="mb-3 text-xl font-semibold leading-7 text-gray-900 max-sm:text-lg max-sm:leading-6">
        {title}
      </h2>
      <p className="mb-5 text-sm leading-5 text-gray-500 max-sm:text-sm max-sm:leading-5">
        {description}
      </p>
      <FeatureList features={features} />
      <div className="flex gap-2 items-center text-sm font-semibold leading-5 text-teal-600 cursor-pointer max-sm:text-sm">
        Learn more
        <i className="ti ti-arrow-right text-base" />
      </div>
    </article>
  );
};

export default ModuleCard;
